
@if (isLoading) {
  <app-loader></app-loader>
} @else if (dataSource.data.length > 0) {
  <div class="user-property-list-table-container">
  <div class="mat-elevation-z8 hide-on-mobile">
    
    <mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="agentId">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Agent ID </mat-header-cell>
            <mat-cell *matCellDef="let agent"> {{ agent.agentId ?? '' }} </mat-cell>
        </ng-container>
        
        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> First Name </mat-header-cell>
            <mat-cell *matCellDef="let agent"> {{ agent.firstName ?? '' }} {{ agent.lastName ?? '' }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Email </mat-header-cell>
            <mat-cell *matCellDef="let agent"> {{ agent.email ?? '' }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="phone">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Phone </mat-header-cell>
            <mat-cell *matCellDef="let agent"> 
              @if(agent.phoneNumber) {
                {{ agent.phoneNumber | phone }} 
              }
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="referringAgentId">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Referred By </mat-header-cell>
            <mat-cell *matCellDef="let agent"> {{ getAgentName(agent.referringAgentId) ?? '' }} </mat-cell>
        </ng-container>

      <mat-header-row *matHeaderRowDef="['agentId', 'name', 'email', 'phone', 'referringAgentId']"></mat-header-row>
      
      <mat-row *matRowDef="let row; columns: ['agentId', 'name', 'email', 'phone', 'referringAgentId'];"></mat-row>
    </mat-table>
  </div>

    <div class="mobile-property-list show-on-mobile" *ngIf="!isLoading">
        <mat-card *ngFor="let agent of dataSource.connect() | async" class="mobile-property-card">
          <mat-card-header>
            <mat-card-title>{{ agent.firstName }} {{ agent.lastName }} | {{ agent.agentId }}</mat-card-title>
          </mat-card-header>
          <mat-card-content style="text-align: left">
              <div *ngIf="agent.email">
                <mat-icon>mail</mat-icon>
                {{ agent.email }}
              </div>
              <div *ngIf="agent.phoneNumber">
                <mat-icon>phone</mat-icon>
                {{ agent.phoneNumber | phone }}
              </div>
              <div *ngIf="agent.referringAgentId">
                <mat-icon>person</mat-icon>
                {{ getAgentName(agent.referringAgentId) }}
              </div>
          </mat-card-content>
        </mat-card>
    </div>

    <mat-paginator 
      #paginator
      [pageSizeOptions]="[5, 10, 25, 100]"
      aria-label="Select page of agents">
    </mat-paginator>
    </div>
} @else {
  <p>No Sales Agents Found</p>
}